(() => {
  'use strict';
  if (window.RhizalStockShip) return;
  const nativeFetch = window.fetch.bind(window);
  const records = new Map();
  const observedCartRoots = new WeakSet();
  const keys = ['Made to order', 'Made-to-order', 'Pre-order', '_rhizal_stock_ship', '_rhizal_in_stock_qty', '_rhizal_pending_qty'];
  const root = window.Shopify?.routes?.root || '/';
  const seed = document.querySelector('[data-rhizal-stock-ship]');
  if (!seed) return;
  const config = JSON.parse(seed.textContent);
  if (!config.enabled) return;
  config.variants.forEach(v => records.set(String(v.id), v));
  function allocateCart(cart) {
    const remaining = new Map();
    return cart.map(item => {
      const variant = {...item.variant};
      const id = String(variant.id);
      const eligible = variant.eligible === true;
      if (!remaining.has(id)) remaining.set(id, Math.max(0, Number(variant.stock) || 0));
      const inStock = eligible ? Math.min(item.quantity, remaining.get(id)) : item.quantity;
      if (eligible) remaining.set(id, remaining.get(id) - inStock);
      variant.inStock = inStock;
      variant.pendingQty = eligible ? item.quantity - inStock : 0;
      variant.pending = variant.pendingQty > 0;
      return {...item, variant};
    });
  }
  function properties(existing, record) {
    const next = {...(Array.isArray(existing) ? Object.fromEntries(existing) : existing || {})};
    keys.forEach(k => delete next[k]);
    if (record.pending) {
      next[record.label] = record.inStock > 0 && record.pendingQty > 0
        ? `${record.inStock} in stock · ${record.pendingQty} ${record.label === 'Pre-order' ? 'pre-order' : 'made to order'}`
        : record.message;
      if (record.pendingQty !== undefined) {
        next._rhizal_in_stock_qty = String(record.inStock);
        next._rhizal_pending_qty = String(record.pendingQty);
      }
    }
    return next;
  }
  async function readSection(path) {
    const url = new URL(path, location.origin);
    if (!/\/variants\//.test(url.pathname)) url.searchParams.set('section_id', 'rhizal-stock-ship');
    url.searchParams.set('_rzss', String(Date.now()));
    const response = await nativeFetch(url, {credentials:'same-origin', cache:'no-store'});
    if (!response.ok) throw new Error('Unable to check fulfillment availability');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = html.querySelector('[data-rhizal-stock-ship]');
    if (!node) throw new Error('Fulfillment data is unavailable');
    const data = JSON.parse(node.textContent);
    if (data.cart) data.cart = allocateCart(data.cart);
    return data;
  }
  async function freshVariant(id) {
    const known = records.get(String(id));
    const data = await readSection(known?.url || root + 'variants/' + encodeURIComponent(id));
    data.variants.forEach(v => records.set(String(v.id), v));
    const record = data.variants.find(v => String(v.id) === String(id));
    if (!record) throw new Error('Variant fulfillment data is unavailable');
    return record;
  }
  function updatePendingIndicator(form, record) {
    const section = form.closest('[id^="ProductSection-"]');
    const text = section?.querySelector('#rhizal-fulfillment-text') ||
      (config.variants.some(v => String(v.id) === String(record.id)) ? document.getElementById('rhizal-fulfillment-text') : null);
    if (!text) return;
    if (!record.pending) {
      // Keep the responsive location spans: flattening textContent removes
      // the mobile California label and forces the longer desktop copy.
      if (text.querySelector('.rhizal-location-desktop, .rhizal-location-mobile')) return;
      const cleaned = text.textContent.replace(/from San Diego, CA from California/g, 'from San Diego, CA');
      if (cleaned !== text.textContent) text.textContent = cleaned;
      return;
    }
    const label = record.label === 'Made to order' ? 'Made-to-order' : record.label;
    const message = record.message.replace(/^Ships\b/, 'ships');
    const expected = `${label} — ${message}`;
    if (text.textContent.trim() === expected) return;
    const emphasis = document.createElement('em');
    emphasis.textContent = label;
    text.replaceChildren(emphasis, document.createTextNode(` — ${message}`));
  }
  function updateForm(form) {
    const id = form.querySelector('[name="id"]')?.value;
    const record = records.get(String(id));
    if (!record) return;
    updatePendingIndicator(form, record);
    form.querySelectorAll('[data-rzss-property]').forEach(el => el.remove());
    keys.forEach(key => form.querySelectorAll('input').forEach(el => {
      if (el.name === `properties[${key}]`) el.remove();
    }));
    if (record.pending) {
      Object.entries(properties({}, record)).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = `properties[${key}]`; input.value = value;
        input.dataset.rzssProperty = ''; form.append(input);
      });
    }
    const button = form.querySelector('[data-add-to-cart]');
    if (!button) return;
    let label = button.querySelector('[data-rzss-label]');
    if (!label && record.pending) {
      label = document.createElement('small'); label.dataset.rzssLabel = ''; button.append(label);
    }
    if (label) { label.textContent = record.label === 'Made to order' ? 'Made-to-order' : record.label; label.dataset.rzssKind = record.label === 'Made to order' ? 'mto' : 'preorder'; label.hidden = !record.pending; }
  }
  const loading = new Set();
  function updateForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const id = form.querySelector('[name="id"]')?.value;
      if (id && !records.has(String(id)) && !loading.has(id)) {
        loading.add(id);
        freshVariant(id).then(() => updateForm(form)).catch(error => console.warn(error)).finally(() => loading.delete(id));
      } else updateForm(form);
    });
  }
  async function prepare(body) {
    if (body instanceof FormData || body instanceof URLSearchParams || typeof body === 'string' && !body.trim().startsWith('{')) {
      const data = body instanceof FormData ? body : new URLSearchParams(body);
      const id = data.get('id');
      if (!id) return body;
      const record = await freshVariant(id);
      keys.forEach(k => data.delete(`properties[${k}]`));
      if (record.pending) Object.entries(properties({}, record)).forEach(([k,v]) => data.set(`properties[${k}]`,v));
      updateForms();
      return body instanceof FormData ? data : data.toString();
    }
    if (typeof body !== 'string') return body;
    const data = JSON.parse(body);
    const items = data.items || [data];
    await Promise.all(items.map(async item => {
      if (!item.id) return;
      const record = await freshVariant(item.id);
      item.properties = properties(item.properties, record);
    }));
    updateForms();
    return JSON.stringify(data);
  }
  let cartQueue = Promise.resolve();
  function cartTask(task) {
    const result = cartQueue.then(task, task);
    cartQueue = result.catch(() => {});
    return result;
  }
  window.fetch = async function(input, init) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
    const method = (init?.method || input?.method || 'GET').toUpperCase();
    const match = url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/);
    if (url.origin !== location.origin || !match || method !== 'POST') return nativeFetch(input, init);
    return cartTask(async () => {
      if (match[1] !== 'add') {
        const response = await nativeFetch(input, init);
        if (response.ok) scheduleReconcile();
        return response;
      }
      try {
        let body = init?.body;
        if (body === undefined && input instanceof Request) body = await input.clone().text();
        const nextBody = await prepare(body);
        const response = input instanceof Request
          ? await nativeFetch(new Request(input, {...init, body:nextBody}))
          : await nativeFetch(input, {...init, body:nextBody});
        if (response.ok) scheduleReconcile();
        return response;
      } catch (error) {
        console.error('Stock and Ship availability check failed', error);
        return new Response(JSON.stringify({status:422, description:config.error}), {status:422, headers:{'Content-Type':'application/json'}});
      }
    });
  };
  function nthWeekdayOfMonth(year, month, weekday, nth) {
    var date = new Date(year, month, 1);
    var offset = (weekday - date.getDay() + 7) % 7;
    date.setDate(1 + offset + (nth - 1) * 7);
    return date;
  }

  function lastWeekdayOfMonth(year, month, weekday) {
    var date = new Date(year, month + 1, 0);

    while (date.getDay() !== weekday) {
      date.setDate(date.getDate() - 1);
    }

    return date;
  }

  function observedHoliday(year, month, day) {
    var date = new Date(year, month, day);

    if (date.getDay() === 6) {
      date.setDate(date.getDate() - 1);
    }
    else if (date.getDay() === 0) {
      date.setDate(date.getDate() + 1);
    }

    return date;
  }

  function sameCalendarDay(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function getPostalHolidays(year) {
    return [
      observedHoliday(year, 0, 1),
      nthWeekdayOfMonth(year, 0, 1, 3),
      nthWeekdayOfMonth(year, 1, 1, 3),
      lastWeekdayOfMonth(year, 4, 1),
      observedHoliday(year, 5, 19),
      observedHoliday(year, 6, 4),
      nthWeekdayOfMonth(year, 8, 1, 1),
      nthWeekdayOfMonth(year, 9, 1, 2),
      observedHoliday(year, 10, 11),
      nthWeekdayOfMonth(year, 10, 4, 4),
      observedHoliday(year, 11, 25)
    ];
  }

  function isPostalHoliday(date) {
    var years = [
      date.getFullYear() - 1,
      date.getFullYear(),
      date.getFullYear() + 1
    ];

    for (var y = 0; y < years.length; y++) {
      var holidays = getPostalHolidays(years[y]);

      for (var i = 0; i < holidays.length; i++) {
        if (sameCalendarDay(date, holidays[i])) {
          return true;
        }
      }
    }

    return false;
  }

  function isShippingDay(date) {
    var day = date.getDay();

    if (day === 0 || day === 6) {
      return false;
    }

    if (isPostalHoliday(date)) {
      return false;
    }

    return true;
  }

  function moveToNextShippingDay(date) {
    while (!isShippingDay(date)) {
      date.setDate(date.getDate() + 1);
    }

    return date;
  }

  function getPacificNow() {
    return new Date(
      new Date().toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles'
      })
    );
  }

  function getShipDateObject() {

    var nowPacific = getPacificNow();
    var shipDate = new Date(nowPacific);

    /* 1 PM Pacific cutoff */
    var afterCutoff = nowPacific.getHours() >= 13;

    if (!isShippingDay(shipDate)) {
      shipDate.setDate(shipDate.getDate() + 1);
      moveToNextShippingDay(shipDate);
    }

    else if (afterCutoff) {
      shipDate.setDate(shipDate.getDate() + 1);
      moveToNextShippingDay(shipDate);
    }

    return shipDate;
  }

  function formatShipDate(shipDate) {

    var weekdayNames = [
      'Sun',
      'Mon',
      'Tues',
      'Wed',
      'Thurs',
      'Fri',
      'Sat'
    ];

    var weekday = weekdayNames[shipDate.getDay()];

    var monthDay = shipDate.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });

    return weekday + ', ' + monthDay;
  }


  // Keep Upcart's visual component and in-stock cutoff display, but source
  // pending estimates from the same section as PDP and checkout properties.
  function pendingCartText(cart) {
    const pending = cart.filter(item => item.variant.pending);
    if (!pending.length) return null;
    const messages = [...new Set(pending.map(item => item.variant.message.trim()))];
    const total = cart.reduce((sum, item) => sum + item.quantity, 0);
    if (messages.length !== 1) return 'Ships together when all items are ready.';
    const message = messages[0];
    if (total > 1) return /^Ships\b/i.test(message) ? message.replace(/^Ships\b/i, 'Ships together') : `Ships together. ${message}`;
    const label = pending[0].variant.label === 'Made to order' ? 'Made-to-order' : pending[0].variant.label;
    return `${label} — ${message.replace(/^Ships\b/, 'ships')}`;
  }
  if (window.customElements) customElements.whenDefined('rhizal-cart-shipping').then(() => {
    const component = customElements.get('rhizal-cart-shipping');
    const paint = component.prototype.update;
    component.prototype.update = function(value) {
      const version = this.rzssVersion = (this.rzssVersion || 0) + 1;
      if (!value || value.kind !== 'amber' || /unavailable/i.test(value.text)) return paint.call(this, value);
      // Hide the legacy estimate while refreshing, rather than flash a stale promise.
      paint.call(this, null);
      readSection(root + 'cart').then(data => {
        if (version !== this.rzssVersion || !this.isConnected) return;
        const text = pendingCartText(data.cart);
        paint.call(this, text ? {...value, text, note:''} : null);
      }).catch(() => { if (version === this.rzssVersion) paint.call(this, null); });
    };
  });

  let syncing;
  function sameProperties(a, b) {
    const normalize = value => Object.entries(value).filter(([k,v]) => k !== '_rhizal_stock_ship' && v !== '' && v != null)
      .map(([k,v]) => [k, String(v)]).sort(([a],[b]) => a.localeCompare(b));
    return JSON.stringify(normalize(a)) === JSON.stringify(normalize(b));
  }
  function syncCart() {
    if (syncing) return syncing;
    syncing = cartTask(async () => {
      let changed = false;
      let data;
      // Re-read after each property mutation: Shopify can change line keys or
      // merge identical lines. Never continue using the previous line snapshot.
      for (let pass = 0; pass < 100; pass++) {
        data = await readSection(root + 'cart');
        const item = data.cart.find(item => {
          const existing = Array.isArray(item.properties) ? Object.fromEntries(item.properties) : item.properties || {};
          return !sameProperties(existing, properties(existing, item.variant));
        });
        if (!item) break;
        const existing = Array.isArray(item.properties) ? Object.fromEntries(item.properties) : item.properties || {};
        const next = properties(existing, item.variant);
        // Shopify cannot clear a properties object to {}. Retain a private marker.
        if (!Object.keys(next).length) next._rhizal_stock_ship = 'in-stock';
        const response = await nativeFetch(root + 'cart/change.js', {
          method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:item.key, quantity:item.quantity, properties:next})
        });
        if (!response.ok) throw new Error('Unable to update fulfillment messaging');
        changed = true;
        if (pass === 99) throw new Error('Cart fulfillment did not settle');
      }
      const hasPending = data.cart.some(item => item.variant.pending);
      const hasStock = data.cart.some(item => item.variant.inStock > 0);
      const expectedDate = hasPending ? '' : data.cart.length ? formatShipDate(getShipDateObject()) : '';
      const attributes = {
        'RHIZAL expected ship date': expectedDate,
        'RHIZAL fulfillment': hasPending ? (hasStock ? 'partial pre-order' : 'pre-order') : ''
      };
      const currentResponse = await nativeFetch(root + 'cart.js', {credentials:'same-origin', cache:'no-store'});
      if (!currentResponse.ok) throw new Error('Unable to read cart');
      const current = await currentResponse.json();
      if (Object.entries(attributes).some(([key,value]) => (current.attributes?.[key] || '') !== value)) {
        const saved = await nativeFetch(root + 'cart/update.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes})});
        if (!saved.ok) throw new Error('Unable to save shipping estimate');
        const savedCart = await saved.json();
        if (Object.entries(attributes).some(([key,value]) => (savedCart.attributes?.[key] || '') !== value)) throw new Error('Shipping estimate was not saved');
      }
      return changed;
    }).finally(() => { syncing = null; });
    return syncing;
  }
  let reconcileTimer;
  let reconciling = false;
  let reconcileAgain = false;
  function scheduleReconcile() {
    formatCartProperties();
    if (reconciling) { reconcileAgain = true; return; }
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(async () => {
      reconciling = true;
      try {
        if (await syncCart()) await window.upcartRefreshCart?.();
      } catch (error) { console.error('Stock and Ship cart reconciliation failed', error); }
      finally {
        reconciling = false;
        if (reconcileAgain) { reconcileAgain = false; scheduleReconcile(); }
      }
    }, 200);
  }
  const subscribed = new Set();
  function bindUpcart() {
    ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartOpened'].forEach(name => {
      if (!subscribed.has(name) && typeof window[name] === 'function') {
        window[name](scheduleReconcile);
        subscribed.add(name);
      }
    });
    return subscribed.size === 3;
  }
  if (!bindUpcart()) {
    let attempts = 0;
    const setup = setInterval(() => { if (bindUpcart() || ++attempts >= 120) clearInterval(setup); }, 500);
  }
  scheduleReconcile();
  const approvedCheckout = new WeakSet();
  const checkoutSelector = 'a[href*="/checkout"], a[href*="/cart/c/"], button[name="checkout"], input[name="checkout"], .upcart-checkout-button';
  window.addEventListener('click', async event => {
    const target = event.composedPath().find(node => node.matches?.(checkoutSelector));
    if (!target) return;
    if (approvedCheckout.has(target)) { approvedCheckout.delete(target); return; }
    event.preventDefault(); event.stopImmediatePropagation();
    try { await syncCart(); approvedCheckout.add(target); target.click(); }
    catch (error) { window.alert(config.error); }
  }, true);
  document.addEventListener('variant:change', () => queueMicrotask(updateForms));
  document.addEventListener('change', event => { if (event.target.closest('form[action*="/cart/add"]')) queueMicrotask(updateForms); });
  document.addEventListener('shopify:section:load', updateForms);
  document.addEventListener('submit', event => { if (event.target.matches('form[action*="/cart/add"]')) updateForm(event.target); }, true);
  function formatCartProperties() {
    const cartRoot = document.getElementById('upCart')?.shadowRoot;
    if (cartRoot && !observedCartRoots.has(cartRoot)) {
      observedCartRoots.add(cartRoot);
      new MutationObserver(formatCartProperties).observe(cartRoot, {childList:true, subtree:true, characterData:true});
    }
    const items = [...document.querySelectorAll('.upcart-public-product-properties__item'),
      ...(cartRoot?.querySelectorAll('.upcart-public-product-properties__item') || [])];
    items.forEach(item => {
      const copy = item.querySelector('.upcart-public-cart-items__key-value-pair');
      if (!copy) return;
      if (/^_rhizal_(?:stock_ship|in_stock_qty|pending_qty)\s*:/.test(copy.textContent.trim())) {
        if (!item.hidden) item.hidden = true;
        return;
      }
      const mixed = copy.textContent.match(/^(?:Made to order|Made-to-order|Pre-order):\s*(\d+ in stock · \d+ (?:made to order|pre-order))$/);
      if (mixed) copy.textContent = mixed[1];
    });
  }
  new MutationObserver(mutations => {
    formatCartProperties();
    if (mutations.some(m => m.target.nodeType === 1 && (m.target.id === 'rhizal-fulfillment-text' || m.target.closest?.('#rhizal-fulfillment-text')))) updateForms();
    if (mutations.some(m => [...m.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('form[action*="/cart/add"]') || n.querySelector?.('form[action*="/cart/add"]'))))) updateForms();
  }).observe(document.body, {childList:true, subtree:true});
  updateForms();
  formatCartProperties();
  window.RhizalStockShip = {allocateCart, sameProperties, pendingCartText, properties, prepare, syncCart, updateForms, records, getShipDateObject, formatShipDate};
})();

